import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const defaultUser = { name: '', email: '', role: 'user', password: '', plan_id: '', end_date: '' };

export default function UserModal({ show, onHide, onSave, user, plans }) {
  const [form, setForm] = useState(defaultUser);
  const [error, setError] = useState('');

  useEffect(() => {
    setForm(user ? { ...user, password: '' } : defaultUser);
    setError('');
  }, [user, show]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.email || (!user && !form.password)) {
      setError('Name, email, and password are required.');
      return;
    }
    onSave(form);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{user ? 'Edit User' : 'Create User'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form.Group className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control name="name" value={form.name} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control name="email" type="email" value={form.email} onChange={handleChange} required />
          </Form.Group>
          {!user && (
            <Form.Group className="mb-2">
              <Form.Label>Password</Form.Label>
              <Form.Control name="password" type="password" value={form.password} onChange={handleChange} required />
            </Form.Group>
          )}
          <Form.Group className="mb-2">
            <Form.Label>Role</Form.Label>
            <Form.Select name="role" value={form.role} onChange={handleChange}>
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="superadmin">Superadmin</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Plan</Form.Label>
            <Form.Select name="plan_id" value={form.plan_id || ''} onChange={handleChange}>
              <option value="">None</option>
              {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Subscription End Date</Form.Label>
            <Form.Control name="end_date" type="date" value={form.end_date ? form.end_date.slice(0,10) : ''} onChange={handleChange} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="primary">{user ? 'Update' : 'Create'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
